// The options a query-builder rule's dropdown renders, extracted from
// components/queryBuilder/FuiRule.vue so it can be tested without a browser.
//
// A rule that takes typed values (URL) has no choices of its own, so a value it
// already holds -- a saved report reopened, or a "Add to report" link from a
// blog post -- had no <option> to render as, and the dropdown showed only its
// placeholder while the filter was in force.
export function ruleOptions(choices, value, allowAddition) {
  const options = Object.values(choices || {});
  if (!allowAddition) return options;

  const known = new Set(options.map((option) => option.value));
  const extra = [...new Set([].concat(value == null ? [] : value))]
    .filter((v) => v !== "" && v !== null && v !== undefined && !known.has(v))
    .map((v) => ({ value: v, label: v }));
  return options.concat(extra);
}
